/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 9th 2022, 8:14:09 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import "./OSDropZone.css";

interface OSDropZoneProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

export const OSDropZone = ({ style, className, children }: OSDropZoneProps) => {
  return (
    <div style={style} className={className ?? "os-drop-zone"}>
      <div className="os-drop-zone-children">{children}</div>
    </div>
  );
};
